/**
 * Sentry error tracking configuration.
 *
 * Same pattern as `supabase-config.ts`: a DSN is a PUBLIC client credential
 * (it ships in every browser bundle; Sentry's own docs call it safe to
 * expose), so committing it here is fine. Unlike Supabase, no default value
 * is baked in — this project's DSN has not been retrieved yet (see
 * docs/TODO.md). Absent a DSN, `initSentry` in `sentry.ts` is a deliberate
 * no-op: the game must never fail to start because error reporting isn't
 * configured.
 *
 * Override per environment via Vite env if needed:
 *   VITE_SENTRY_DSN
 */

export interface SentryConfig {
  dsn: string;
}

const DEFAULT_DSN = '';

export function getSentryConfig(): SentryConfig | null {
  const env = (import.meta as { env?: Record<string, string | undefined> }).env ?? {};
  const dsn = env.VITE_SENTRY_DSN ?? DEFAULT_DSN;
  if (!dsn) return null;
  return { dsn };
}
